<template>
  <div class="marginApplicationPage">
    <div class="wrap">
      <van-cell-group class="baseNone baseSalary">
        <van-field v-model="propertyData.applicantIdName" readonly label="申请人：" class="ggInput" />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="propertyData.applyTime"
          label="申请时间："
          readonly
          placeholder
          class="ggInput"
          input-align="right"
        />
      </van-cell-group>

      <van-cell-group class="baseNone baseSalary moreText">
        <van-field
          v-model="propertyData.amount"
          placeholder
          readonly
          class="ggInput"
          input-align="right"
          clearable
          type="number"
          v-enterIntNumber
          required
          label="金额（元）："
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary beizhu">
        <van-field
          v-model="propertyData.reason"
          placeholder
          class="ggInput"
          input-align="right"
          clearable
          readonly
          required
          label="用款原因："
          rows="1"
          autosize
          type="textarea"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="propertyData.proceedsCompany"
          clearable
          class="ggInput"
          input-align="right"
          readonly
          required
          label="收款单位："
          placeholder
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="propertyData.proceedsAccount"
          class="ggInput"
          input-align="right"
          clearable
          readonly
          required
          label="收款账号："
          placeholder
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary moreText">
        <van-field
          :value="propertyData.type=='tb'?'投标保证金':propertyData.type=='ly'?'履约保证金':propertyData.type=='ly_bh'?'履约保函保证金':propertyData.type=='yfk_bh'?'预付款保函保证金':''"
          label="保证金类型："
          readonly
          class="ggInput"
          input-align="right"
        />
      </van-cell-group>
      <!-- 所属项目 -->
      <van-cell-group class="itemSite baseNone beizhu">
        <van-field
          v-model="propertyData.linkName"
          type="textarea"
          class="ggInput"
          input-align="right"
          label="所属项目："
          readonly
          rows="1"
          autosize
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary moreText">
        <van-field
          v-model="propertyData.payTime"
          label="要求支付时间："
          readonly
          class="ggInput"
          input-align="right"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary moreText" v-if="propertyData.expectReturnTime != null">
        <van-field
          v-model="propertyData.expectReturnTime"
          label="预计退还时间："
          readonly
          class="ggInput"
          input-align="right"
        />
      </van-cell-group>
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
import newApi from "lodash";
import { mapState, mapMutations } from "vuex";
const refreshPage = () => import("@/components/common/refreshPage");
import { dateFormat, getDictList } from "@/utils/common";
import { getDeviceType, closePage,is_wei } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "marginApplication-detail",
  props: {
    id: {
      //借款记录id
      type: String,
      default: ""
    }
  },
  data() {
    return {
      editType: false, //能否编辑
      refreshPage: false, // 网络请求失败时显示
      propertyData: {
        applyTime: "", //申请时间
        linkName: "", //项目名称
        linkId: "", //项目编号id
        type: "", //保证金类型
        amount: "", //保证金金额
        payTime: "", //要求支付时间
        expectReturnTime: "", //预计退还时间
        reason: "", //用款原因
        proceedsCompany: "", //收款单位
        proceedsAccount: "", //收款账号
        verifyStatus: "hold",
        applicantIdName: ""
      }
    };
  },
  async mounted() {
      if(is_wei()){
      document.title="保证金申请";
    }
    this.commonId = this.id; //申请Id
    this.$nextTick(() => {
      this.initPage();
    });
  },
  components: {
    refreshPage
  },
  methods: {
    initPage() {
      let _this = this;
      _this.$api.finance.margin
        .detail(_this.commonId)
        .then(res => {
          if (res.code == "1" && res.data != null) {
            _this.propertyData = newApi.assign(
              {},
              _this.propertyData,
              res.data
            );
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch(err => {
          _this.$toast("网络失败，请稍后重试");
        });
    }
  },
  computed: {
    ...mapState(["showLoad", "userinfo"])
  },
  watch: {}
};
</script>
<style lang="less">
.marginApplicationPage {
  width: 100%;
  min-height: 100%;
  background-color: #fff;
  .roleBox {
    width: 100%;
    height: 100%;
    padding-top: 15px;
    // overflow-y: initial;
  }
  #searchHeight {
    text-align: left;
  }
  .baseNone {
    .van-field__body {
      .van-field__control {
        text-align: right;
        color: #969799;
      }
    }
  }
  .baseNone.moreText {
    .van-cell {
      .van-cell__title {
        width: 140px;
      }
    }
  }
  .baseNone.beizhu {
    min-height: 45px;
  }
  .btnBox {
    width: 100%;
    padding: 0 14px;
    height: 65px;
    position: fixed;
    left: 0;
    bottom: 0;
    padding-top: 10px;
    z-index: 1009;
    background-color: #fff;
    button {
      width: 100%;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
      span {
        line-height: 45px;
      }
    }
  }

  //审批记录样式
  .approveList {
    margin-top: 10px;
  }
  //流程图样式
  .flowList {
    margin-top: 10px;
  }
}
</style>